import { render, staticRenderFns } from "./GPPContainer.vue?vue&type=template&id=93a4f4d0&scoped=true"
import script from "./GPPContainer.vue?vue&type=script&lang=js"
export * from "./GPPContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a4f4d0",
  null
  
)

export default component.exports